import store from '../index';
import apiClient from '../../services/api-client';

const state = {
	rateDropOptions: [],
};

const mutations = {
	GET_RATE_DROP_OPTIONS_SUCCESS(state, payload) {
		state.rateDropOptions = payload;
	},
};

const actions = {
	async getRateDropOptions({ commit }, payload) {
		try {
			const response = await apiClient().post(
				'/PreferenceCenter/GetAllPreferenceParameterValues',
				payload,
			);
			if (response && response.data) {
				const options =
					response.data[0].parameters.RatePercentageIncrements.map(
						(element, index) => ({
							id: index + 1,
							value: element,
							name: element + '%',
						}),
					);
				commit('GET_RATE_DROP_OPTIONS_SUCCESS', options);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
};

const getters = {
	isValidPreferences({ rootState }) {
		return (_) =>
			!(
				!store.state.licenses.disclaimerTextSelected ||
				!store.state.complianceLogos.complianceLogoSelected
			);
	},
};

export default {
	state,
	mutations,
	actions,
	getters,
};
